import { ControlType, FetchStatus } from "../../../../base/types";
import { CookieRegistrationProperties, useCookieRegistration } from "./useCookieRegistration";
import { ErrorMessage, Spinner } from "../../../../widgets";

import { CookieRegistration } from "./CookieRegistration";
import { DraftCookieRegistration } from "./DraftCookieRegistration";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const CookieRegistrationComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, error } = useCookieRegistration(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) {
        return <></>
    }

    return <CookieRegistration className={className} {...properties} />
}

Registry.addControl({
    id: "1ead4303-05cd-4f5c-a090-492d4d940a38",
    name: "Cookie Registration",
    type: ControlType.CookieRegistration,
    properties: CookieRegistrationProperties,
    component: CookieRegistrationComponent,
    draftComponent: DraftCookieRegistration
})
